import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const lookupAffiliateByCode = createServerFn({ method: "POST" })
  .inputValidator(z.object({ code: z.string().min(1).max(64) }).parse)
  .handler(async ({ data }) => {
    const { lookupAffiliateByCodeServer } = await import("./affiliate.server");
    return lookupAffiliateByCodeServer(data);
  });
